var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWifiOnGrey(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "49px",
    height: "37px",
    viewBox: "0 0 49 37",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "noun_Mobile Wifi_749921 Copy 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Meeting-Room-Booking",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "UpcomingReservation_Open_NetworkError",
    transform: "translate(-1286.000000, -367.000000)",
    fill: "#C9C9C9",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "noun_Mobile-Wifi_749921-Copy-2",
    transform: "translate(1287.000000, 367.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.41138728,12.5822135 C13.6498201,0.207418458 33.5601063,0.207418458 45.7985391,12.5822135 C45.8898706,12.6745627 46.0725338,12.7669119 46.255197,12.7669119 C46.4378602,12.7669119 46.6205233,12.6745627 46.7118549,12.5822135 C46.9858497,12.3051658 46.9858497,11.8434197 46.7118549,11.6587213 C33.9254326,-1.27016901 13.1931621,-1.27016901 0.406739817,11.6587213 C0.132745053,11.935769 0.132745053,12.397515 0.406739817,12.5822135 C0.680734581,12.7669119 1.13739252,12.8592611 1.41138728,12.5822135 Z",
    id: "Path",
    stroke: "#C9C9C9",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08324068,21.2630398 C9.35723544,21.5400875 9.81389338,21.5400875 9.99655656,21.2630398 C17.4857468,13.6904041 29.7241796,13.6904041 37.2133698,21.2630398 C37.3047014,21.355389 37.4873645,21.4477382 37.6700277,21.4477382 C37.8526909,21.4477382 38.0353541,21.355389 38.1266857,21.2630398 C38.4006804,20.9859922 38.4006804,20.5242461 38.1266857,20.3395476 C30.0895059,12.2128166 17.0290888,12.2128166 9.08324068,20.3395476 C8.80924591,20.6165953 8.80924591,20.9859922 9.08324068,21.2630398 Z",
    id: "Path",
    stroke: "#C9C9C9",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.79065604,16.9226266 C5.0646508,17.1996743 5.52130874,17.1996743 5.70397192,16.9226266 C19.0987634,4.58937382 31.6436429,8.58289201 41.597286,16.9226266 C41.7061931,17.0138753 41.8712808,17.1073251 42.0539439,17.1073251 C42.2366071,17.1073251 42.4192703,17.0149759 42.5106019,16.9226266 C42.7845966,16.645579 42.7845966,16.1838329 42.5106019,15.9991345 C29.4783899,3.45472061 13.8514728,6.48622634 4.79065604,15.9991345 C4.5276325,16.2752816 4.51666128,16.645579 4.79065604,16.9226266 Z",
    id: "Path-Copy",
    stroke: "#C9C9C9",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3758253,24.6799608 C13.1018305,24.9570085 13.1018305,25.4187546 13.3758253,25.603453 C13.6498201,25.8805006 14.106478,25.8805006 14.2891412,25.603453 C19.4037101,20.4318969 27.7148846,20.4318969 32.8294536,25.603453 C32.9207851,25.6958022 33.1034483,25.7881514 33.2861115,25.7881514 C33.4687747,25.7881514 33.6514378,25.6958022 33.7427694,25.603453 C34.0167642,25.3264053 34.0167642,24.8646593 33.7427694,24.6799608 C28.2628742,18.9543094 19.0383838,18.9543094 13.3758253,24.6799608 Z",
    id: "Path",
    stroke: "#C9C9C9",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8062162,31.6985013 C27.8062162,29.3897709 25.9795845,27.4504373 23.6049632,27.4504373 C21.3216735,27.4504373 19.4037101,29.2974216 19.4037101,31.6985013 C19.4037101,34.0072317 21.2303419,35.9465652 23.6049632,35.9465652 C25.8882529,35.9465652 27.8062162,34.0072317 27.8062162,31.6985013 Z M20.7736839,31.6985013 C20.7736839,30.1285646 22.0523262,28.8356756 23.6049632,28.8356756 C25.1576002,28.8356756 26.4362424,30.1285646 26.4362424,31.6985013 C26.4362424,33.268438 25.1576002,34.561327 23.6049632,34.561327 C22.0523262,34.561327 20.7736839,33.268438 20.7736839,31.6985013 Z",
    id: "Shape",
    stroke: "#C9C9C9",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.7101059,-3.29375824 C26.7023483,-4.83248638 26.7056677,-5.95300817 25.7001162,-5.99137904 C24.6945647,-6.02974992 24.7095205,-4.8421795 24.7172782,-3.30345136 L24.9325526,39.3962545 C24.9403102,40.9349827 24.8792858,42.0762336 25.9425423,42.0940728 C27.0057988,42.1115171 26.933138,40.9446758 26.9253803,39.4059477 L26.7101059,-3.29375824 Z",
    id: "Path",
    stroke: "#444444",
    strokeWidth: 0.5,
    transform: "translate(25.822477, 18.050895) rotate(-315.000000) translate(-25.822477, -18.050895) "
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWifiOnGrey);
export default __webpack_public_path__ + "static/media/WifiOnGrey.708aafe2b3795a67137b8ac3597c26e5.svg";
export { ForwardRef as ReactComponent };